<script>
/**
 * ****************************************************************************
 * @description     :   Datalist Component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import _ from 'lodash';
import _u from 'lodash-uuid';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of select component
 */
var AnsDataList = {
    template: template,
    props: {
        id: String,
        label: String,
        style: String,
        itemClass: String,
        buttonClass: String,
        labelClass: String,
        labelBefore: String,
        labelAfter: String,
        inputClass: String,
        placeholder: String,
        value: String,
        modelValue: [String, Number],
        isRequired: Boolean,
        isDisabled: Boolean,
        isDisabledIcon: Boolean,
        isReadonly: Boolean,
        isMobile: {
            type: Boolean,
            default: false
        },
        type: String,
        isDecimal: {
            type: Boolean,
            default: false
        },
        isDisableIME: {
            type: Boolean,
            default: false
        },
        decimal: Number,
        isNegative: Boolean,
        maxLength: Number,
        cols: Number,
        rows: Number,
        icon: String,
        isInputGroup: Boolean,
        onChange: Function,
        onFocus: Function,
        onBlur: Function,
        onClick: Function,
        options: Array,
        keyValueOptions: {
            type: Array,
            default: ['code', 'name']
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            isFocus: false,
            realMaxLength: undefined,
            newId: ''
        };
    },
    mounted() {
        this.realMaxLength = this.getRealMaxLength();
        // create uuid
        if (this.id && this.id != '') {
            this.newId = this.id;
        } else {
            this.newId = _u.uuid();
        }
    },
    computed: {
        vewValue: {
            get() {
                const val = this.convertNumber(this.modelValue ? this.modelValue : this.value);
                if (this.isFocus && !this.isDisabled && !this.isReadonly) {
                    // eslint-disable-next-line prettier/prettier
                    return this.type == 'money' || (this.type == 'measure' && !this.isDecimal)
                        ? val.replace(/,/g, '')
                        : this.type == 'postcode'
                        ? val.replace(/-/g, '')
                        : val;
                }
                return val;
            },
            set() {}
        },
        listOptions() {
            const vm = this;
            if (!vm.options) {
                return [
                    {
                        [vm.keyValueOptions[0]]: '',
                        [vm.keyValueOptions[1]]: ''
                    }
                ];
            }
            const idx = _.findIndex(vm.options, function (o) {
                return o[[vm.keyValueOptions[1]]] === '' || o[vm.keyValueOptions[1]] === 'すべて' || o[vm.keyValueOptions[1]] === '全て';
            });
            if (idx < 0) {
                vm.options.unshift({
                    [vm.keyValueOptions[0]]: '',
                    [vm.keyValueOptions[1]]: ''
                });
            }
            return vm.options;
        }
    },
    methods: {
        /**
         * convert number type for input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        convertNumber(value) {
            if (value == undefined || value == '' || value == null) {
                return '';
            }
            value = value + '';
            let values = [];
            let negative = '';
            let dot = '';
            let afterDot = '';
            if (this.type == 'number' || this.type == 'money' || this.type == 'measure') {
                if (this.isNegative && value.startsWith('-')) {
                    negative = '-';
                }
                values = value.split('.');
                values[0] = values[0].replace(/\D/g, '');
                if (values.length > 1) {
                    afterDot = values[1].replace(/\D/g, '');
                    if (afterDot.length > this.decimal) {
                        afterDot = afterDot.substring(0, this.decimal);
                    }
                    dot = '.';
                    this.isDecimal ? (value = negative + values[0] + dot + afterDot) : (value = negative + values[0]);
                }
                if (this.type == 'measure' && !this.isDecimal) {
                    values[0] = values[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    value = negative + values[0];
                }
                if (this.type == 'money') {
                    values[0] = values[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    values[0] = values[0].replace(/^0+/, '');
                    if (values[0]) {
                        value = negative + '¥' + values[0] + (values.length > 1 ? '.' + values[1] : '');
                    } else {
                        value = negative + '¥' + values[0] + (values.length > 1 ? '.' + values[1] : '0');
                    }
                }
                if (this.isDecimal && this.decimal > 0 && afterDot === '' && value.length > this.maxLength - this.decimal) {
                    dot = '.';
                    afterDot = values[0].substring(this.maxLength - this.decimal, value.length);
                    values[0] = values[0].substring(0, this.maxLength - this.decimal);
                    this.isDecimal ? (value = negative + values[0] + dot + afterDot) : (value = negative + values[0]);
                }
                if (!values[0]) {
                    values[0] = 0;
                }
            }
            if (this.type == 'postcode') {
                const postcode = value.replace(/\D/g, '');
                if (postcode.length >= 7) {
                    value = postcode.slice(0, 3) + '-' + postcode.slice(3, 7);
                } else {
                    value = '';
                }
            }
            return value;
        },
        /**
         * get max lenght input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        getRealMaxLength(e) {
            if (this.maxLength == undefined || this.maxLength == null || this.type != 'money' || this.type != 'measure') {
                let maxLength = this.maxLength;
                if (e) {
                    if (this.type == 'number') {
                        if (e.target.value.indexOf('-') >= 0) {
                            maxLength += 1;
                        }
                        if (e.target.value.indexOf('.') >= 0) {
                            maxLength += 1;
                        }
                    }
                    if (this.type == 'postcode') {
                        if (e.target.value.indexOf('-') >= 0) {
                            maxLength += 1;
                        }
                    }
                }
                return maxLength;
            }
            return this.maxLength + (parseInt(this.maxLength / 3) + (this.maxLength % 3 > 0 ? 0 : -1));
        },
        /**
         * event forcus on input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        focusInput(e) {
            //e.target.select();
            this.isFocus = true;
            this.realMaxLength = this.maxLength;
            if (this.onFocus) {
                this.onFocus(e);
            }
        },
        /**
         * event blur on input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        blurInput(e) {
            this.isFocus = false;
            this.realMaxLength = this.getRealMaxLength(e);
            if (this.onBlur) {
                this.onBlur(e);
            }
        },
        /**
         * event keydown on input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        inputKeydown(e) {
            if (this.type == 'number' && this.isDecimal) {
                return this.inputOnlyDecimal(e);
            }
            if (this.type == 'number' || this.type == 'money' || this.type == 'measure' || this.type == 'postcode') {
                return this.inputOnlyNumber(e);
            }
            if (this.type == 'tel') {
                return this.inputOnlyTel(e);
            }
        },
        inputKeyup(e) {
            let maxLength = this.maxLength;
            if (this.type == 'number') {
                if (e.target.value.indexOf('-') >= 0) {
                    maxLength += 1;
                }
                if (e.target.value.indexOf('.') >= 0) {
                    maxLength += 1;
                }
            }
            if (this.type == 'postcode') {
                if (e.target.value.indexOf('-') >= 0) {
                    maxLength += 1;
                }
            }
            if (this.type == 'measure' && this.isDecimal) {
                if (e.target.value.indexOf('.') >= 0) {
                    maxLength += 1;
                }
            }
            this.realMaxLength = maxLength;
            if (this.type == 'postcode' && this.realMaxLength != e.target.value.length) {
                return false;
            }
            this.$emit('update:modelValue', e.target.value);
            return true;
        },
        /**
         * event block key on input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        inputOnlyNumber(e) {
            if (
                !(
                    (e.keyCode > 47 && e.keyCode < 58) ||
                    (e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 13
                ) ||
                (!this.isNegative && e.keyCode == 189) ||
                e.keyCode == 109
            ) {
                event.preventDefault();
                return false;
            }
            return true;
        },
        /**
         * event block key on input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        inputOnlyDecimal(e) {
            if (
                !(
                    (e.keyCode > 47 && e.keyCode < 58) ||
                    (e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 110 ||
                    e.keyCode == 190 ||
                    e.keyCode == 13
                ) ||
                (!this.isNegative && e.keyCode == 189) ||
                e.keyCode == 109
            ) {
                event.preventDefault();
                return false;
            }
            return true;
        },
        /**
         * event block key on input with type tel
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        inputOnlyTel(e) {
            if (
                !(
                    (!e.shiftKey && e.keyCode > 47 && e.keyCode < 58) ||
                    (!e.shiftKey && e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 107 ||
                    e.keyCode == 109 ||
                    (!e.shiftKey && e.keyCode == 189) ||
                    (e.shiftKey && e.keyCode == 57) ||
                    (e.shiftKey && e.keyCode == 48) ||
                    (e.shiftKey && e.keyCode == 187)
                )
            ) {
                event.preventDefault();
                return false;
            }
            return true;
        },
        /**
         * update input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        updateInput(e) {
            const val = this.convertNumber(this.$refs.input.value);
            let value = this.type == 'money' ? val.replace(/,/g, '') : val;
            if (this.type == 'measure' && this.isDecimal) {
                const values = val.split('.');
                let dot = '';
                let afterDot = '';
                if (values.length > 1) {
                    afterDot = values[1].replace(/\D/g, '');
                    if (afterDot.length > this.decimal) {
                        afterDot = afterDot.substring(0, this.decimal);
                    }
                    dot = '.';
                }
                value = values[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + dot + afterDot;
            }
            this.$emit('update:modelValue', value);
            if (this.onChange) {
                this.onChange(e, value);
            }
        }
    }
};
export default AnsDataList;
</script>
